<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0 bg-image">
        <div class="flex items-center justify-center">
            <img src="/images/banner-img.webp" alt="" srcset="" class="img-animation size-72">
        </div>
        <div class="flex items-center justify-center">
            <p-button label="Explore Horoscope" />
        </div>
    </div>
</div>